const escapeRegExp = (text)=> {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  }

  export default escapeRegExp